interface IProps {}

export const SbError: React.FC<IProps> = ({ children }) => {
	return (
		<div className="mt-1 text-xs font-medium text-error">
			<span>{children}</span>
		</div>
	);
};
